<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<template>
  <div
    v-if="canRenderDetails"
    :data-epi-content-id="isOptiEditOrPreviewMode ? optiDbJobPageRef?.contentLink.guidValue : null"
    class="careers-page mb-[100px] flex w-full flex-col items-center justify-center"
  >
    <div class="relative w-full items-center">
      <!-- Hero image -->
      <VcImage
        v-if="careersLocationPageRef?.heroImage?.url"
        v-epi-edit="'HeroImage'"
        :src="careersLocationPageRef.heroImage.url"
        :alt="careersLocationPageRef.heroImage.caption || $t('pages.careers.heroImageAlt')"
        class="h-auto w-full object-contain"
        multiple-dpr
        :default-size="DEFAULT_IMAGE_SIZE"
      />

      <!-- Title overlay -->
      <div
        v-if="careersLocationPageRef?.title"
        class="medium-container absolute inset-x-0 bottom-[34px] mx-auto md:px-0"
      >
        <h1
          ref="titleRef"
          v-html-safe="careersLocationPageRef.title"
          class="m-0 text-[40px] font-bold leading-[48px] text-[--color-white]"
        ></h1>
      </div>
    </div>

    <CareersLocationMenu />

    <!-- LOCATION DESCRIPTION & BENEFITS DIV -->
    <div class="flex flex-col items-start py-10">
      <div class="medium-container flex items-center justify-center md:mx-[-16px] lg:mx-0">
        <div class="flex flex-col gap-2">
          <!--Location title-->
          <h3 v-html-safe="careersLocationPageRef?.title || ''" class="m-0 text-[30px] font-bold leading-[38px]"></h3>
          <!--Location description-->
          <div
            v-epi-edit="'LocationDescription'"
            v-html-safe="careersLocationPageRef?.locationDescription || ''"
            class="flex flex-col gap-5 font-medium leading-6"
          ></div>
        </div>
      </div>
      <!-- Red red-separator -->
      <div class="medium-container mx-auto my-0">
        <span
          class="red-separator my-[30px] flex h-0.5 w-12 rounded-full bg-[--color-primary-a1] md:mx-[-16px] lg:mx-0"
        ></span>
      </div>

      <div
        v-if="
          (careersLocationPageRef?.locationBenefits && careersLocationPageRef.locationBenefits.length > 0) ||
          careersLocationPageRef?.benefitsDescription
        "
        class="flex w-full items-center justify-center md:mx-[-16px] lg:mx-0"
      >
        <div class="medium-container flex flex-col justify-between gap-6 md:flex-row md:gap-[70px]">
          <div class="flex flex-1 flex-col gap-2.5">
            <h3 class="m-0 text-[30px] font-bold leading-[38px]">{{ $t("pages.careers.benefits_title") }}</h3>
            <!--Benefits description div-->
            <div
              v-if="careersLocationPageRef?.benefitsDescription"
              v-epi-edit="'BenefitsDescription'"
              v-html-safe="careersLocationPageRef?.benefitsDescription || ''"
              class="flex flex-col gap-5"
            ></div>
          </div>

          <div
            v-if="careersLocationPageRef?.locationBenefits && careersLocationPageRef.locationBenefits.length > 0"
            v-epi-edit="'Benefits'"
            class="flex flex-col lg:w-[407px]"
          >
            <BlockRenderer
              v-for="(block, index) in careersLocationPageRef.locationBenefits"
              :key="index"
              :content-area-item="block"
              :class="[
                'items-center',
                careersLocationPageRef.locationBenefits.length === 1
                  ? 'border-b border-b-[--color-neutral-a4] pb-4'
                  : 'border-b border-b-[--color-neutral-a4] py-4',

                index === careersLocationPageRef.locationBenefits.length - 1 &&
                careersLocationPageRef.locationBenefits.length > 1
                  ? 'border-b-0'
                  : '',
              ]"
            />
          </div>
        </div>
      </div>
    </div>

    <!--WORKABLE JOBS DESCRIPTION-->
    <div v-show="showWorkableJobDetailsRef" class="medium-container">
      <div class="flex flex-col items-start rounded-md border border-[--color-neutral-a4] md:mx-[-16px] lg:mx-0">
        <div class="flex w-full flex-col items-start gap-5 border-b px-[30px] py-5">
          <VcButton variant="link" size="lg" class="!font-medium" @click.prevent="onBackToJobsListClicked">
            <VcIcon name="arrow-left" class="mr-1 size-4"></VcIcon>
            {{ $t("pages.careers.backToAllPositions") }}</VcButton
          >
          <div class="flex w-full flex-col items-start justify-between gap-4 lg:flex-row lg:gap-0">
            <div class="flex flex-col gap-1.5">
              <h3 class="m-0 text-2xl font-bold leading-[30px]" v-text="selectedJob?.title || ''"></h3>
              <p class="font-medium leading-6">{{ selectedJob?.city }}, {{ selectedJob?.state }}</p>
            </div>
          </div>
        </div>
        <div class="flex w-full flex-col items-start gap-5 p-5 last-of-type:border-b-0 md:px-[30px]">
          <iframe :src="selectedJob?.url" title="Job Description" width="100%" height="800"></iframe>
        </div>
      </div>
    </div>

    <!-- DATABASE JOB DESCRIPTION-->
    <div v-show="false == showWorkableJobDetailsRef" class="medium-container careers-job-details">
      <div class="flex flex-col items-start rounded-md border border-[--color-neutral-a4]">
        <div class="flex w-full flex-col items-start gap-5 border-b px-[30px] py-5">
          <VcButton variant="link" size="lg" class="!font-medium" @click.prevent="onBackToJobsListClicked">
            <VcIcon name="arrow-left" class="mr-1 size-4"></VcIcon>
            {{ $t("pages.careers.backToAllPositions") }}</VcButton
          >
          <div class="flex w-full flex-col items-start justify-between gap-4 lg:flex-row lg:gap-0">
            <div class="flex flex-col gap-1.5">
              <h3 v-epi-edit="'Title'" class="m-0 text-2xl font-bold leading-[30px]">{{ selectedJob?.title }}</h3>
              <p class="font-medium leading-6">{{ selectedJob?.locationString }}</p>
            </div>
            <div class="flex gap-2.5">
              <a :href="'mailto:' + optiDbJobPageRef?.contactEmail + '?subject=' + selectedJob?.title">
                <VcButton class="!min-w-[92px]" color="primary" size="lg" variant="solid">{{
                  $t("pages.careers.apply")
                }}</VcButton>
              </a>
            </div>
          </div>
        </div>

        <div class="flex w-full flex-col items-start gap-5 px-[30px] py-5 last-of-type:border-b-0">
          <h4 v-show="optiDbJobPageRef?.description" class="m-0 text-base font-bold leading-6">
            {{ $t("pages.careers.description") }}
          </h4>
          <section
            v-epi-edit="'Description'"
            class="flex flex-col gap-2.5"
            v-html="optiDbJobPageRef?.description || ''"
          ></section>

          <h4 v-show="optiDbJobPageRef?.knowledgeAndSkills" class="m-0 text-base font-bold leading-6">
            {{ $t("pages.careers.knowledgeAndSkills") }}
          </h4>
          <section v-epi-edit="'KnowledgeAndSkills'" v-html="optiDbJobPageRef?.knowledgeAndSkills || ''"></section>
          <h4 v-show="optiDbJobPageRef?.requirements" class="m-0 text-base font-bold leading-6">
            {{ $t("pages.careers.requirements") }}
          </h4>
          <section
            v-epi-edit="'Requirements'"
            class="flex flex-col gap-2.5"
            v-html="optiDbJobPageRef?.requirements || ''"
          ></section>

          <a :href="'mailto:' + optiDbJobPageRef?.contactEmail + '?subject=' + selectedJob?.title">
            <VcButton class="!min-w-[92px]" color="primary" size="lg" variant="solid">{{
              $t("pages.careers.apply")
            }}</VcButton>
          </a>
        </div>
      </div>
    </div>
  </div>
  <VcLoaderOverlay v-else-if="isResolving" />
</template>

<!--TYPESCRIPT-->
<script lang="ts" setup>
/*eslint-disable prettier/prettier*/
/*eslint-disable curly */
import { provideApolloClient } from "@vue/apollo-composable";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { apolloClient } from "@/core/api/graphql";
import { usePageHead } from "@/core/composables/usePageHead";
import { useCareersLocations } from "@/shared/thorlabs/careers/composables/useCareersLocations";
import {
  fetchWorkableJobsAsJobOpportunitiesAsync,
  fetchCareerJobPostingPageByJobIDAsync,
  getPageByUrlAsync,
  mapJobPostingPageToJobOpportunity,
} from "@/shared/thorlabs/careers/utils";
import { BlockRenderer } from "@/shared/thorlabs/shared";
import { useEditMode } from "@/shared/thorlabs/shared/composables";
import type { ICareersJobPostingPage, ICareersLocationPage, JobOpportunityType } from "@/shared/thorlabs/careers";
import type { Ref } from "vue";
import CareersLocationMenu from "@/shared/thorlabs/careers/components/careers-location-menu.vue";

interface IProps {
  country?: string;
  jobID?: string;
  page?: ICareersJobPostingPage; //This will be only used in Opti edit/preview mode, for user browsing page is fetched using logic in watch below
}
const props = defineProps<IProps>();

const optiEditContext = useEditMode();
const isOptiEditOrPreviewMode = computed(() => optiEditContext.isEditable.value || optiEditContext.isPreview.value);

const router = useRouter();
const { locations: careersLocations, load: loadCareersLocations, getLocation } = useCareersLocations();
const activeJobLocations = computed(() =>
  careersLocations.value.map((location) => ({
    country: location.country,
    state: location.state,
    label: location.label,
    permalink: location.permalink,
    contentLinkId: location.page.contentLink.id,
  })),
);

//This will only have a value if the the target job is coming from Optimizely
const optiDbJobPageRef: Ref<ICareersJobPostingPage | undefined> = ref(undefined);

const careersLocationPageRef: Ref<ICareersLocationPage | undefined> = ref(undefined);
const careersLocationPageURLRef: Ref<string | undefined> = ref(undefined);

usePageHead({
  title: computed(() => (careersLocationPageRef.value?.country ? `${careersLocationPageRef.value.country.trim()} Careers` : "Careers")),
});

const workableJobsList: Ref<JobOpportunityType[] | undefined> = ref(undefined);

const selectedJob: Ref<JobOpportunityType | undefined> = ref(undefined);

const showWorkableJobDetailsRef: Ref<boolean> = ref(false);
const isResolving = ref(true);
const canRenderDetails = computed(
  () => isOptiEditOrPreviewMode.value || Boolean(selectedJob.value && careersLocationPageRef.value),
);

const titleRef = ref<HTMLHeadingElement | null>(null);

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("md");
const DEFAULT_IMAGE_SIZE = isMobile.value ? 480 : 1920;

//If job ID is changed in URL or page is updated (from Opti preview mode), update relevant values
watch(
  () => [props.jobID, props.page],
  async () => {
    isResolving.value = true;
    selectedJob.value = undefined;
    careersLocationPageRef.value = undefined;

    //If this page is accessed from Opti preview mode, then page content will be passed through matcher and we don't need to fetch it manually
    if (props.page && isOptiEditOrPreviewMode.value) {
      //In Opti edit/preview mode we need to get the jobID from the page object
      optiDbJobPageRef.value = props.page;
      selectedJob.value = mapJobPostingPageToJobOpportunity(props.page);
      showWorkableJobDetailsRef.value = false;
    } else if (props.jobID) {
      await loadCareersLocations();

      //Normal user browsing case, this page is routed through Vue router and not matcher which means we have to get page or workable content here
      if (workableJobsList.value === undefined)
        workableJobsList.value = await fetchWorkableJobsAsJobOpportunitiesAsync(activeJobLocations.value);

      const workableJob = workableJobsList.value.find((job) => job.shortcode === props.jobID);

      if (workableJob) {
        optiDbJobPageRef.value = undefined;
        selectedJob.value = workableJob;
        showWorkableJobDetailsRef.value = true;
      } else {
        //It is not a workable job, try to get Opti DB job page using job ID
        const dbJobPage = await provideApolloClient(apolloClient)(() =>
          fetchCareerJobPostingPageByJobIDAsync(props.jobID!)
        );

        if (dbJobPage) {
          const activeParentLocation = careersLocations.value.find(
            (location) => location.page.contentLink.id === dbJobPage.parentLink?.id,
          );

          if (!activeParentLocation) {
            isResolving.value = false;
            await router.replace("/404");
            return;
          }

          optiDbJobPageRef.value = dbJobPage;
          selectedJob.value = mapJobPostingPageToJobOpportunity(dbJobPage);
          showWorkableJobDetailsRef.value = false;
        } else {
          isResolving.value = false;
          await router.replace("/404");
          return;
        }
      }

      //scrollToTitle();
    }

    //We have gotten job page (from Opti or workable), now get its parent location page

    let locationPageURL: string | undefined;
    let careersLocationPage: ICareersLocationPage | undefined;
    //Opti edit/preview mode has different URLs so we need to get parent career location page a different way
    if (isOptiEditOrPreviewMode.value) {
      const parentPageURL = props.page?.parentLink?.url ?? "";
      //This is done to cut-out the /en/ part of the URL, we expect careers home page to have URL segment /careers/
      locationPageURL = parentPageURL.substring(parentPageURL.lastIndexOf("/careers/"));
      careersLocationPage = await provideApolloClient(apolloClient)(() =>
        getPageByUrlAsync<ICareersLocationPage>(locationPageURL!)
      );
    } else if (optiDbJobPageRef.value) {
      //Normal user browsing case, get location page from Opti job page
      const careerLocationOptiID = optiDbJobPageRef.value?.parentLink?.id;
      const activeLocation = careersLocations.value.find(
        (location) => location.page.contentLink.id === careerLocationOptiID,
      );
      locationPageURL = activeLocation?.permalink;
      careersLocationPage = activeLocation?.page;
    } else if (showWorkableJobDetailsRef.value) {
      //Workable job case, get location page from job
      const jobLocationModel = getLocation(selectedJob.value?.country, selectedJob.value?.state);

      if (jobLocationModel) {
        locationPageURL = jobLocationModel.permalink;
        careersLocationPage = jobLocationModel.page;
      }
    }

    careersLocationPageURLRef.value = locationPageURL;
    careersLocationPageRef.value = careersLocationPage;
    isResolving.value = false;

    if (!isOptiEditOrPreviewMode.value && (!selectedJob.value || !careersLocationPageRef.value)) {
      await router.replace("/404");
    }
  },
  { immediate: true },
);

function onBackToJobsListClicked() {
  if (isOptiEditOrPreviewMode.value)
    //Do nothing in Opti edit/preview mode or we don't have location page URL
    return;

  //Navigate back from wherever use came (not just to parent location page but possibly to global search page)
  router.go(-1);
}

/*function scrollToTitle() {
  if (!titleRef.value) return;

  titleRef.value.scrollIntoView({
    behavior: "instant",
    block: "start",
  });
}*/
</script>

<!--CSS-->
<style lang="scss">
.careers-job-details {
  ul {
    li {
      @apply pl-6 min-w-full -indent-6;

      &:before {
        @apply inline-block align-middle content-[""] ml-2 mr-3 -mt-0.5 w-1 h-1 bg-[--color-neutral-a1] rounded-full;
      }
    }
  }
  ol {
    @apply list-none; // Remove default bullets

    counter-reset: custom-counter; // Reset the counter

    li {
      @apply pl-6 min-w-full relative;

      counter-increment: custom-counter; // Increment for each <li>

      &::before {
        content: counter(custom-counter) ".";
        @apply absolute left-0 top-0 text-[--color-neutral-a1] mr-3;
        width: 1.5em; // optional: aligns numbers visually
        display: inline-block;
      }
    }
  }
}
</style>
